module.exports = __webpack_public_path__ + "img/jiantou2.3d1ee3de.png";